import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../../../../utilities/LogErrors'

import { InstructorBase } from './../../../../Layouts/Instructor/V2/InstructorBase'
import { Loading } from './../../../../Common/Loading'
import { SupportContent } from './../../../../Common/Support/SupportContent'

import { ValidateSession } from './../../../../../utilities/BL/Sessions'
import { WEBPAGES } from './../../../../../utilities/EL/WebPages'
import { ROLES } from './../../../../../utilities/EL/Roles'


// Atención al Instructor
// Estructura base tomada de Help.js (validación de sesión + InstructorBase); el contenido
// (QR, frases, medios de contacto y horario) es el mismo de la página de Atención al Líder.

const Support = () => {
    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(true)

    /**
     * Función para obtener la configuración, una vez que termine de cargarse el componente
     */
    useEffect(() => {
        async function Validate() {
            try {
                const tmpSession = await ValidateSession()

                if (tmpSession.success) {
                    if (tmpSession.data.user.userStatus === 2) {
                        setIsLoading(false)
                    } else {
                        navigate('/confirm')
                    }
                } else {
                    navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
                }
            } catch (error) {
                await LogErrors('Validate - Support', error)
            }
        }
        Validate()
    }, []) // eslint-disable-line

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <InstructorBase urlToGo={'/dashboard'} page={WEBPAGES.INSTRUCTOR.SUPPORT} role={ROLES.INSTRUCTOR}>
                    <SupportContent title='Atención al Instructor' />
                </InstructorBase>
            )}
        </>
    )
}

export { Support };
